import React, { useState, useEffect } from "react";
import { useCartao } from "../../hooks/cartao";
import publicIp from "public-ip";
import {
  desbloqueio,
  dadosCompletos,
  termos,
  buscaCep,
  orgaosRg,
  estadoCivil,
  estados,
  cartoes,
  enviarCartao,
} from "../../services/cartao";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  AiFillWarning,
  AiFillIdcard,
  AiFillCheckCircle,
  AiOutlineCheck,
} from "react-icons/ai";

import { TailSpin } from "react-loading-icons";

const AtualizarDados: React.FC = () => {
  const {
    cartaoCpf,
    tTelefone,
    tEmail,
    codigo,
    passo,
    erro,
    qtCartoes,
    celularToken,
    emailToken,
    carregarBeneficiario,
    alteraPasso,
    alteraErro,
    alteraCodigo,
    alteraQtCartoes,
    alteraDadosCartoes,
    alteraTokenTelefone,
    alteraTokenEmail,
    alteraCarregarBeneficiario,
  } = useCartao();

  useEffect(() => {
    if (codigo !== "" && carregarBeneficiario) {
      getDados();
    }
  });

  const [sucesso, setSucesso] = useState<boolean>(false);
  const [ufDados, setUfDados] = useState<any[]>([]);
  const [ecDados, setEcDados] = useState<any[]>([]);
  const [orgaosDados, setOrgaosDados] = useState<any[]>([]);
  const [loadingCep, setLoadingCep] = useState<boolean>(false);
  const [disabledBairro, setDisabledBairro] = useState<boolean>(true);
  const [disabledLogradouro, setDisabledLogradouro] = useState<boolean>(true);
  const [enviaCartao, setEnviaCartao] = useState<boolean>(false);
  const [emailCartao, setEmailCartao] = useState<string>("");
  const [emailCartaoFat, setEmailCartaoFat] = useState<string>("");
  const [termosAceite, setTermosAceite] = useState<string>("");
  const [nomeBeneficiario, setNomeBeneficiario] = useState<string>("");
  const [formaPgto, setFormaPgto] = useState<string>("");
  const [erroEnviaCartao, setErroEnviaCartao] = useState<string>("");
  const [beneficiarioLoading, setBeneficiarioLoading] =
    useState<boolean>(false);
  const [dadosForm, setDadosForm] = useState({
    nomeMae: "",
    dataNascimento: "",
    estadoCivil: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    uf: "",
    rg: "",
    orgaoExpRg: "",
    ufEmissorRg: "",
    dataExpedicaoRg: "",
    telefone: "",
    telefone1: "",
    telefone2: "",
    celular: "",
    celular1: "",
    celular2: "",
    email: "",
    email1: "",
    email2: "",
    aceito: false,
    enviar_cartao: false,
    promocoes: false,
  });

  async function getDados() {
    if (!beneficiarioLoading && nomeBeneficiario === "") {
      setBeneficiarioLoading(true);

      let beneficiario = await dadosCompletos(codigo);

      if (beneficiario.dados) {
        setNomeBeneficiario(beneficiario.dados.a012_nm_usuario);

        let celular = `${beneficiario.dados.a012_ddd_celular}${beneficiario.dados.a012_celular}`;
        if (beneficiario.dados.a012_ddd_celular_sms === "") {
          celular = `${beneficiario.dados.a012_ddd_celular_sms}${beneficiario.dados.a012_num_celular_sms}`;
        }

        let dtNasc: string = beneficiario.dados.a012_dt_nasc;
        let dtNascArr = dtNasc.split("/");

        let dtRg: string = beneficiario.dados.a012_dt_expedicao_rg;
        let dtRgArr = dtRg.split("/");
        setEmailCartao(beneficiario.dados.a012_email);
        setFormaPgto(beneficiario.dados.a003_forma_pagamento);
        setEmailCartaoFat(beneficiario.dados.a003_email_fat);
        setDadosForm({
          nomeMae: beneficiario.dados.a012_nm_mae,
          dataNascimento:
            dtNascArr.length > 1
              ? `${dtNascArr[2]}-${dtNascArr[1]}-${dtNascArr[0]}`
              : "",
          estadoCivil: beneficiario.dados.a017_cd_estado_civil,
          cep: beneficiario.dados.a003_cep_lograd,
          logradouro: beneficiario.dados.a003_nm_lograd,
          numero: beneficiario.dados.a003_num_lograd,
          complemento: beneficiario.dados.a003_compl_lograd,
          bairro: beneficiario.dados.a904_abrev_bairro,
          cidade: beneficiario.dados.a902_nm_cidade,
          uf: beneficiario.dados.a901_sigla,
          rg: beneficiario.dados.a012_rg,
          orgaoExpRg: beneficiario.dados.a012_orgao_exped_rg,
          ufEmissorRg: beneficiario.dados.uf_expedicao_rg,
          dataExpedicaoRg:
            dtRgArr.length > 1
              ? `${dtRgArr[2]}-${dtRgArr[1]}-${dtRgArr[0]}`
              : "",
          telefone: phoneMask(
            `${beneficiario.dados.a012_ddd_telefone}${beneficiario.dados.a012_telefone}`
          ),
          telefone1: phoneMask(
            `${beneficiario.dados.a012_ddd_telefone_1}${beneficiario.dados.a012_telefone_1}`
          ),
          telefone2: phoneMask(
            `${beneficiario.dados.a012_ddd_telefone_2}${beneficiario.dados.a012_telefone_2}`
          ),
          celular: celular,
          celular1: phoneMask(
            `${beneficiario.dados.a012_ddd_celular_1}${beneficiario.dados.a012_celular_1}`
          ),
          celular2: phoneMask(
            `${beneficiario.dados.a012_ddd_celular_2}${beneficiario.dados.a012_celular_2}`
          ),
          email: beneficiario.dados.a012_email,
          email1: beneficiario.dados.a012_email_1,
          email2: beneficiario.dados.a012_email_2,
          aceito: false,
          enviar_cartao: false,
          promocoes: false,
        });

        if (termosAceite === "") {
          let termosResponse = await termos();
          setTermosAceite(termosResponse);
        }

        if (ecDados.length === 0) {
          let ec = await estadoCivil();
          let ecList = Object.entries(ec.dados);
          setEcDados(ecList);
        }

        if (orgaosDados.length === 0) {
          let orgaos = await orgaosRg();
          let orgaosList = Object.entries(orgaos.dados);
          setOrgaosDados(orgaosList);
        }

        if (ufDados.length === 0) {
          let uf = await estados();
          let ufList = Object.entries(uf.dados);
          setUfDados(ufList);
        }
        setBeneficiarioLoading(false);
      }
      alteraCarregarBeneficiario(false);
    }
  }

  const validationSchema = Yup.object().shape({
    // nomeMae: Yup.string().required("Este campo é obrigatório"),
    // dataNascimento: Yup.string().required("Este campo é obrigatório"),
    // estadoCivil: Yup.string().required("Este campo é obrigatório"),
    // cep: Yup.string().required("Este campo é obrigatório"),
    // logradouro: Yup.string().required("Este campo é obrigatório"),
    // numero: Yup.string().required("Este campo é obrigatório"),
    // bairro: Yup.string().required("Este campo é obrigatório"),
    // cidade: Yup.string().required("Este campo é obrigatório"),
    // uf: Yup.string().required("Este campo é obrigatório"),
    // celular: Yup.string().required("Este campo é obrigatório"),
    // email1: Yup.string()
    //   .nullable()
    //   .email("Informe um endereço de e-mail válido"),
    // email2: Yup.string()
    //   .nullable()
    //   .email("Informe um endereço de e-mail válido"),
    aceito: Yup.boolean().oneOf(
      [true],
      "É necessário aceitar os termos para desbloquear o cartão"
    ),
  });

  const handleSubmit = async (values: any) => {
    setBeneficiarioLoading(true);
    alteraErro("");
    let ip = await publicIp.v4();
    let dados = {
      token_sms: tTelefone,
      token_email: tEmail,
      codigo: codigo,
      ip,
      novo: "1",
      ...values,
    };

    if (!values.enviar_cartao) {
      delete dados.enviar_cartao;
    }
    const returnDesbloqueio = await desbloqueio(dados);
    if (returnDesbloqueio.error) {
      if (typeof returnDesbloqueio.msg === "object") {
        let msg = "";
        Object.entries(returnDesbloqueio.msg).forEach(([key, val]: any) => {
          msg = val[0];
        });
        alteraErro(msg);
      } else {
        alteraErro(returnDesbloqueio.msg);
      }
      setBeneficiarioLoading(false);
    } else {
      let post = {};
      if (cartaoCpf.length <= 11) {
        post = { cpf: cartaoCpf };
      } else {
        post = { cartao: cartaoCpf };
      }
      const returnCartoes = await cartoes(post);
      if (returnCartoes.error) {
        alteraPasso(0);
        alteraErro(returnCartoes.msg);
      } else {
        setSucesso(true);
        alteraQtCartoes(returnCartoes.qt);
        alteraDadosCartoes(returnCartoes.cartoes);
        setDadosForm({
          nomeMae: "",
          dataNascimento: "",
          estadoCivil: "",
          cep: "",
          logradouro: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          uf: "",
          rg: "",
          orgaoExpRg: "",
          ufEmissorRg: "",
          dataExpedicaoRg: "",
          telefone: "",
          telefone1: "",
          telefone2: "",
          celular: "",
          celular1: "",
          celular2: "",
          email: "",
          email1: "",
          email2: "",
          aceito: false,
          enviar_cartao: false,
          promocoes: false,
        });
        setBeneficiarioLoading(false);
      }
      alteraPasso(1);
    }
  };

  const finalizar = async () => {
    if (enviaCartao) {
      setBeneficiarioLoading(true);
      setErroEnviaCartao("");
      let ip = await publicIp.v4();
      let dados = {
        email: emailCartao,
        email_faturamento: emailCartaoFat,
        codigo: codigo,
        ip,
      };

      if (formaPgto === "E" || formaPgto === "T") {
        setErroEnviaCartao(
          "É necessário informar um e-mail para receber suas faturas"
        );
      }
      const returnEnvio = await enviarCartao(dados);
      if (returnEnvio.error) {
        if (typeof returnEnvio.msg === "object") {
          let msg = "";
          Object.entries(returnEnvio.msg).forEach(([key, val]: any) => {
            msg = val[0];
          });
          setErroEnviaCartao(msg);
        } else {
          setErroEnviaCartao(returnEnvio.msg);
        }
        setBeneficiarioLoading(false);
      } else {
        alteraPasso(1);
        alteraCodigo("");
        setSucesso(false);
        setBeneficiarioLoading(false);
      }
    }else{
      alteraPasso(1);
      alteraCodigo("");
      setSucesso(false);
      setBeneficiarioLoading(false);
    }

    if(qtCartoes === 0){
      window.location.reload();
    }
  };

  const phoneMask = (phone: string) => {
    return phone
      .replace(/\D/g, "")
      .replace(/^(\d)/, "($1")
      .replace(/^(\(\d{2})(\d)/, "$1) $2")
      .replace(/(\d{4})(\d{1,5})/, "$1-$2")
      .replace(/(-\d{5})\d+?$/, "$1");
  };

  const cancelar = () => {
    alteraTokenTelefone("");
    alteraTokenEmail("");
    alteraCodigo("");
    alteraPasso(1);
    setBeneficiarioLoading(false);
    setNomeBeneficiario("");
  };

  return (
    <>
      {sucesso && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full text-green-600 sm:mx-0 sm:h-10 sm:w-10">
                    <AiFillCheckCircle size="100" />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3
                      className="text-lg leading-6 font-medium text-gray-900"
                      id="modal-title"
                    >
                      Seu cartão foi desbloqueado
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Seu cartão foi desbloqueado com sucesso!
                      </p>
                    </div>
                    <div className="flex flex-wrap">
                      <div className="w-full my-2 text-center">
                        <a
                          className="w-full flex flex-col items-center py-4 px-8 mb-4 sm:mb-0 mr-6 leading-none text-red-600 bg-gray-100 hover:bg-gray-200 font-semibold rounded shadow"
                          href={`https://api.dentaluni.com.br/beneficiario/cartao/visualizar/${codigo}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <AiFillIdcard size={100} />
                          Baixar cartão
                        </a>
                      </div>
                      <div className="w-full my-2 text-center">
                        <label className="flex flex-shrink items-center text-sm leading-7 cursor-pointer">
                          <input
                            type="checkbox"
                            className="block mr-2"
                            checked={enviaCartao}
                            onChange={(e) => {
                              setEnviaCartao(e.target.checked);
                            }}
                          />{" "}
                          Receber o Cartão Virtual por e-mail?
                        </label>
                      </div>

                      {erroEnviaCartao !== "" && erroEnviaCartao !== null && (
                        <div className="w-full mx-auto my-4 ">
                          <div className="flex items-center justify-between px-6 py-2 bg-red-600 text-white border border-red-500 rounded-lg shadow-xl">
                            <div className="flex">
                              <AiFillWarning />
                              <p className="text-sm font-semibold tracking-wide uppercase ">
                                <strong>Erro:</strong> {erroEnviaCartao}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {enviaCartao && (
                        <div className="w-full my-2 text-center">
                          <label className="flex flex-shrink items-center text-sm leading-7 cursor-pointer font-bold">
                            E-mail para receber o cartão
                          </label>
                          <input
                            placeholder="E-mail para receber o cartão"
                            type="text"
                            className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                            value={emailCartao}
                            onChange={(e) => {
                              setEmailCartao(e.target.value);
                            }}
                          />
                        </div>
                      )}
                      {(formaPgto === "E" || formaPgto === "T") && (
                        <div className="w-full my-2 text-center">
                          <label className="flex flex-shrink items-center text-sm leading-7 cursor-pointer font-bold">
                            Email de faturamento
                          </label>
                          <input
                            placeholder="Email de faturamento"
                            type="text"
                            className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                            value={emailCartaoFat}
                            onChange={(e) => {
                              setEmailCartaoFat(e.target.value);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  onClick={() => {
                    finalizar();
                  }}
                  disabled={beneficiarioLoading}
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  {beneficiarioLoading ? (
                    <TailSpin className="h-5 px-2" speed="1" />
                  ) : (
                    <AiOutlineCheck className="h-5" />
                  )}
                  <b className="px-2 font-medium">Finalizar</b>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {passo === 2 && beneficiarioLoading && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block align-center justify-center text-center overflow-hidden transform transition-all sm:my-8 sm:align-middle mx-auto">
              <TailSpin className="h-10 px-2" speed="2" stroke="white" />
            </div>
          </div>
        </div>
      )}
      {passo === 2 && !beneficiarioLoading && nomeBeneficiario !== "" && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full lg:max-w-6xl">
              <Formik
                initialValues={dadosForm}
                enableReinitialize
                onSubmit={async (values, { setSubmitting }) => {
                  await handleSubmit(values);
                  setSubmitting(false);
                }}
                validationSchema={validationSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  isSubmitting,
                  setFieldValue,
                }: any) => (
                  <Form className="w-full">
                    <div className="bg-gray-50 px-4 py-3 sm:px-6">
                      <h1 className="text-lg leading-6 font-bold text-theme">
                        {nomeBeneficiario}
                      </h1>
                      {/* <h3 className="text-lg leading-6 font-medium text-gray-900">
                        Atualização cadastral
                      </h3> */}
                    </div>
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      {erro !== "" &&
                        erro !== null &&
                        typeof erro !== "string" && (
                          <div className="w-full mx-auto  my-4 ">
                            <div className="flex items-center justify-between px-6 py-2 mx-6 bg-red-600 text-white border border-red-500 rounded-lg shadow-xl">
                              <div className="flex">
                                <AiFillWarning />
                                <p className="text-sm font-semibold tracking-wide uppercase ">
                                  <strong>Erro:</strong>
                                  {Object.keys(erro).map((item, ktmp) => (
                                    <p>{erro[item]}</p>
                                  ))}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        {/* <div className="flex flex-col w-full my-6 transition duration-500 ease-in-out transform bg-white lg:mt-0">
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-2/4">
                              <div className="relative">
                                <label
                                  htmlFor="nomeMae"
                                  className="text-base leading-7"
                                >
                                  Nome da mãe
                                </label>
                                <Field
                                  name="nomeMae"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.nomeMae && touched.nomeMae
                                    ? errors.nomeMae
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="dataNascimento"
                                  className="text-base leading-7"
                                >
                                  Data de nascimento
                                </label>
                                <Field
                                  name="dataNascimento"
                                  type="date"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />

                                <div className="text-red-500 text-sm leading-7">
                                  {errors.dataNascimento &&
                                  touched.dataNascimento
                                    ? errors.dataNascimento
                                    : null}
                                </div>
                              </div>
                            </div>

                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="estadoCivil"
                                  className="text-base leading-7"
                                >
                                  Estado civil
                                </label>
                                <Field
                                  name="estadoCivil"
                                  as="select"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                >
                                  <option value="">Selecione</option>
                                  {ecDados &&
                                    ecDados.map((item, ktmp) => (
                                      <option value={item[0]} key={ktmp+Math.random()}>
                                        {item[1]}
                                      </option>
                                    ))}
                                </Field>
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.estadoCivil && touched.estadoCivil
                                    ? errors.estadoCivil
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="cep"
                                  className="text-base leading-7"
                                >
                                  CEP
                                </label>
                                <div className="relative">
                                  <div className="absolute top-4 left-3">
                                    <i className="fa fa-search text-gray-400 z-20 hover:text-gray-500"></i>
                                  </div>
                                  <Field
                                    name="cep"
                                    placeholder=""
                                    className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                  />

                                  <div className="absolute top-0 right-0">
                                    <button
                                      type="button"
                                      disabled={loadingCep}
                                      className="p-2 m-1 text-white rounded-lg bg-red-500 hover:bg-red-600"
                                      onClick={async () => {
                                        setLoadingCep(true);
                                        let cep = await buscaCep(values.cep);
                                        if (!cep.erro) {
                                          if (cep.logradouro === "") {
                                            setDisabledLogradouro(false);
                                          }
                                          if (cep.bairro === "") {
                                            setDisabledBairro(false);
                                          }
                                          setFieldValue("uf", cep.uf);
                                          setFieldValue("cidade", cep.cidade);
                                          setFieldValue("bairro", cep.bairro);
                                          setFieldValue(
                                            "logradouro",
                                            cep.logradouro
                                          );
                                        } else {
                                          errors.cep = "CEP não encontrado";
                                        }
                                        setLoadingCep(false);
                                      }}
                                    >
                                      {loadingCep ? (
                                        <TailSpin
                                          className="h-4 px-2"
                                          speed="1"
                                          stroke="red"
                                        />
                                      ) : (
                                        <AiOutlineSearch size="18" />
                                      )}
                                    </button>
                                  </div>
                                </div>

                                <div className="text-red-500 text-sm leading-7">
                                  {errors.cep && touched.cep
                                    ? errors.cep
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-2/4 ">
                              <div className="relative">
                                <label
                                  htmlFor="logradouro"
                                  className="text-base leading-7"
                                >
                                  Logradouro
                                </label>
                                <Field
                                  disabled={disabledLogradouro}
                                  name="logradouro"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.logradouro && touched.logradouro
                                    ? errors.logradouro
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="numero"
                                  className="text-base leading-7"
                                >
                                  Número
                                </label>
                                <Field
                                  name="numero"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.numero && touched.numero
                                    ? errors.numero
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="complemento"
                                  className="text-base leading-7"
                                >
                                  Complemento
                                </label>
                                <Field
                                  name="complemento"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.complemento && touched.complemento
                                    ? errors.complemento
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="bairro"
                                  className="text-base leading-7"
                                >
                                  Bairro
                                </label>
                                <Field
                                  disabled={disabledBairro}
                                  name="bairro"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.bairro && touched.bairro
                                    ? errors.bairro
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="cidade"
                                  className="text-base leading-7"
                                >
                                  Cidade
                                </label>
                                <Field
                                  disabled
                                  name="cidade"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.cidade && touched.cidade
                                    ? errors.cidade
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="uf"
                                  className="text-base leading-7"
                                >
                                  UF
                                </label>
                                <Field
                                  disabled
                                  name="uf"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.uf && touched.uf ? errors.uf : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="rg"
                                  className="text-base leading-7"
                                >
                                  RG
                                </label>
                                <Field
                                  name="rg"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.rg && touched.rg ? errors.rg : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="orgaoExpRg"
                                  className="text-base leading-7"
                                >
                                  Orgão de expedição
                                </label>
                                <Field
                                  name="orgaoExpRg"
                                  as="select"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                >
                                  <option value="">Selecione</option>
                                  {orgaosDados &&
                                    orgaosDados.map((item, ktmp) => (
                                      <option value={item[1]} key={ktmp+Math.random()}>
                                        {item[1]}
                                      </option>
                                    ))}
                                </Field>
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.orgaoExpRg && touched.orgaoExpRg
                                    ? errors.orgaoExpRg
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="ufEmissorRg"
                                  className="text-base leading-7"
                                >
                                  UF Emissor
                                </label>
                                <Field
                                  name="ufEmissorRg"
                                  as="select"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                >
                                  <option value="">Selecione</option>
                                  {ufDados &&
                                    ufDados.map((item, ktmp) => (
                                      <option value={item[1]} key={ktmp+Math.random()}>
                                        {item[1]}
                                      </option>
                                    ))}
                                </Field>
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.ufEmissorRg && touched.ufEmissorRg
                                    ? errors.ufEmissorRg
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/4">
                              <div className="relative">
                                <label
                                  htmlFor="dataExpedicaoRg"
                                  className="text-base leading-7"
                                >
                                  Data expedição
                                </label>
                                <Field
                                  name="dataExpedicaoRg"
                                  type="date"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.dataExpedicaoRg &&
                                  touched.dataExpedicaoRg
                                    ? errors.dataExpedicaoRg
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-1/6 ">
                              <div className="relative">
                                <label
                                  htmlFor="telefone"
                                  className="text-base leading-7"
                                >
                                  Telefone
                                </label>
                                <Field
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      "telefone",
                                      phoneMask(e.target.value)
                                    );
                                  }}
                                  name="telefone"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />

                                <div className="text-red-500 text-sm leading-7">
                                  {errors.telefone && touched.telefone
                                    ? errors.telefone
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/6">
                              <div className="relative">
                                <label
                                  htmlFor="telefone1"
                                  className="text-base leading-7"
                                >
                                  Telefone 1
                                </label>
                                <Field
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      "telefone1",
                                      phoneMask(e.target.value)
                                    );
                                  }}
                                  name="telefone1"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.telefone1 && touched.telefone1
                                    ? errors.telefone1
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/6">
                              <div className="relative">
                                <label
                                  htmlFor="telefone2"
                                  className="text-base leading-7"
                                >
                                  Telefone 2
                                </label>
                                <Field
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      "telefone2",
                                      phoneMask(e.target.value)
                                    );
                                  }}
                                  name="telefone2"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.telefone2 && touched.telefone2
                                    ? errors.telefone2
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/6">
                              <div className="relative">
                                <label
                                  htmlFor="celular"
                                  className="text-base leading-7"
                                >
                                  Celular
                                </label>
                                <Field
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      "celular",
                                      phoneMask(e.target.value)
                                    );
                                  }}
                                  name="celular"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.celular && touched.celular
                                    ? errors.celular
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/6">
                              <div className="relative">
                                <label
                                  htmlFor="celular1"
                                  className="text-base leading-7"
                                >
                                  Celular 1
                                </label>
                                <Field
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      "celular1",
                                      phoneMask(e.target.value)
                                    );
                                  }}
                                  name="celular1"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.celular1 && touched.celular1
                                    ? errors.celular1
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-1/6">
                              <div className="relative">
                                <label
                                  htmlFor="celular2"
                                  className="text-base leading-7"
                                >
                                  Celular 2
                                </label>
                                <Field
                                  onChange={(e: any) => {
                                    setFieldValue(
                                      "celular2",
                                      phoneMask(e.target.value)
                                    );
                                  }}
                                  name="celular2"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.celular2 && touched.celular2
                                    ? errors.celular2
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-1/6">
                              <div className="relative">
                                <label
                                  htmlFor="celular2"
                                  className="text-base leading-7"
                                >
                                  Celular de token
                                </label>
                                <input
                                  name="cel_token"
                                  readOnly
                                  type="text"
                                  value={celularToken}
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col gap-2 mb-2 lg:flex-row ">
                            <div className="w-full lg:w-2/4">
                              <div className="relative">
                                <label
                                  htmlFor="email"
                                  className="text-base leading-7"
                                >
                                  E-mail
                                </label>
                                <Field
                                  name="email"
                                  readOnly
                                  value={emailToken}
                                  type="email"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                              </div>
                            </div>
                            <div className="w-full lg:w-2/4">
                              <div className="relative">
                                <label
                                  htmlFor="email1"
                                  className="text-base leading-7"
                                >
                                  E-mail 2
                                </label>
                                <Field
                                  name="email1"
                                  type="email"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.email1 && touched.email1
                                    ? errors.email1
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="w-full lg:w-2/4">
                              <div className="relative">
                                <label
                                  htmlFor="email2"
                                  className="text-base leading-7"
                                >
                                  E-mail 3
                                </label>
                                <Field
                                  name="email2"
                                  type="email"
                                  placeholder=""
                                  className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                />
                                <div className="text-red-500 text-sm leading-7">
                                  {errors.email2 && touched.email2
                                    ? errors.email2
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        <div className="mt-2">
                          <h1 className="text-theme font-semibold">
                            Termo de desbloqueio
                          </h1>
                          <p
                            className="text-sm text-gray-500 overflow-y-scroll max-h-40 my-5 border p-2"
                            dangerouslySetInnerHTML={{
                              __html: termosAceite,
                            }}
                          ></p>
                          <label className="flex flex-shrink items-center text-sm leading-7">
                            <Field
                              type="checkbox"
                              name="aceito"
                              className="mr-2"
                            />
                            Aceito os termos para desbloqueio do cartão
                          </label>
                          <div className="text-red-500 text-sm leading-7">
                            {errors.aceito && touched.aceito
                              ? errors.aceito
                              : null}
                          </div>
                          <label className="flex flex-shrink items-center text-sm leading-7">
                            <Field
                              type="checkbox"
                              name="promocoes"
                              className="mr-2"
                            />
                            Quero receber informações, ofertas, promoções da
                            Dental Uni e de seus parceiros comerciais através de
                            e-mail, WhatsApp, SMS e quaisquer outros meios de
                            comunicação disponíveis durante e após vigência do
                            contrato, autorizando desde já a disponibilização
                            dos dados pessoais a esses parceiros.
                          </label>
                        </div>
                      </div>
                    </div>
                    {erro !== "" && erro !== null && typeof erro === "string" && (
                      <div className="w-full mx-auto  my-4 ">
                        <div className="flex items-center justify-between px-6 py-2 mx-6 bg-red-600 text-white border border-red-500 rounded-lg shadow-xl">
                          <div className="flex">
                            <AiFillWarning />
                            <p className="text-sm font-semibold tracking-wide uppercase ">
                              <strong>Erro:</strong> {erro}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        disabled={loadingCep || isSubmitting}
                        type="submit"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        {isSubmitting && (
                          <TailSpin className="h-5 px-2" speed="1" />
                        )}
                        Salvar dados e desbloquear
                      </button>
                      <button
                        onClick={() => {
                          cancelar();
                        }}
                        disabled={loadingCep || isSubmitting}
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Cancelar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AtualizarDados;
